<template>
  <div class="line">
    <div class="line-left">
      <div class="bg1"></div>
    </div>
    <div ref="linechart" class="linechart"></div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope97",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "饼图-scope97",
      timer: null,
      defaultdata: [
        { value1: "事件结束", value2: "25" },
        { value1: "其他", value2: "15" },
        { value1: "未标注分类", value2: "25" },
        { value1: "焦点(含讨论)异化", value2: "50" },
        { value1: "媒体探访/事件回溯", value2: "80" },
        { value1: "大v网民评论", value2: "80" },
        { value1: "主动回应(含解读)", value2: "150" },
        { value1: "被动回应(含解读/曲解)", value2: "150" },
        { value1: "事件首爆", value2: "500" },
        { value1: "事件进展", value2: "250" },
      ],
      valueMap: [
        { name: "名称", key: "value1" },
        { name: "数值", key: "value2" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      config: {},
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n.filter(
          (item) => item && item[this.valueMap[0].key]
        );
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata(n) {
      this.DrawEcharts();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.linechart);
      let colorData = ["#e09b2c", "#004cc8", "#f26361", "#00ffbf", "#00d9ff"];
      let mydata = this.defaultdata.map((item, i) => {
        let newitem = {
          name: item.value1,
          value: item.value2,
          itemStyle: { color: colorData[i] },
        };
        return newitem;
      });
      var Toption = {
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            //选中ple的中间40-50
            center: ["50%", "50%"],
            radius: ["55%", "65%"],
            label: {
              color: "#C6D2D8",
              fontSize: 12,
              alignTo: "labelLine",
              align: "left",
              // formatter: function (params) {
              // 	// console.log(params, "|l3|");
              // 	let newFor = `${params.data.name}\n金额:${params.data.value}`;
              // 	return newFor
              // },
            },
            labelLine: {
              lineStyle: {
                color: "#748496",
              },
            },
            // labelLayout: function (params) {
            // 	const isLeft = params.labelRect.x < myChart.getWidth() / 2;
            // 	const points = params.labelLinePoints;
            // 	// Update the end point.
            // 	points[2][0] = isLeft
            // 		? params.labelRect.x
            // 		: params.labelRect.x + params.labelRect.width;
            // 	return {
            // 		labelLinePoints: points
            // 	};
            // },
            data: mydata,
          },
        ],
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(function () {
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
  },
  created() {},
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    this.setData()
    this.DrawEcharts(); //需要刷新的数据
  },
};
</script>

<style scoped>
.line {
  width: 435px;
  height: 240px;
  display: flex;
  position: relative;
  overflow: hidden;
  padding: 10px 0;
}

.line-left {
  width: 100%;
  height: 100%;
}

.line-left .bg1 {
  width: 180px;
  height: 180px;
  margin: 48px auto 0px;
  box-sizing: border-box;
  background: url("@/assets/pie-bg5.png") no-repeat;
  background-size: 100%;
  /* position: relative; */
  /* z-index: 1; */
}

.linechart {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  z-index: 5;
}
</style>
